export default __webpack_public_path__ + "static/media/ww10.57cfe4ce.png";